
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {TranslateModule} from "@ngx-translate/core";
import {CardResolve} from "./card.resolve";
import {CardHistoryComponent} from "./cardHistory.component";
import {CardByUuidResolve} from "./cardByUuid.resolve";
import {CardComponent} from "./card.component";
import {MatDividerModule} from "@angular/material/divider";
import {AddVoucherDialogComponent} from "./dialog/addVoucherDialog.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {SuspendCardVoucherDialogComponent} from "./dialog/suspendCardVoucherDialog.component";
import {CardErrorLogsComponent} from "./cardErrorLogs.component";
import {CustomerModule} from "../customer/customer.module";
import {LogTransformer} from "./pipe/logTransformer";
import {UnsuspendCardDialogComponent} from "./dialog/unsuspendCardDialog.component";
import {ActiveVouchersComponent} from "./activeVouchers.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {
    MarkAsReturnedDialogComponent,
} from "./dialog/markAsReturnedDialog.component";

@NgModule({
    declarations: [
        CardHistoryComponent,
        CardComponent,
        AddVoucherDialogComponent,
        SuspendCardVoucherDialogComponent,
        CardErrorLogsComponent,
        LogTransformer,
        UnsuspendCardDialogComponent,
        ActiveVouchersComponent,
        MarkAsReturnedDialogComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatTooltipModule,
        MatDialogModule,
        MatToolbarModule,
        TranslateModule,
        MatDividerModule,
        MatDatepickerModule,
        CustomerModule,
        MatExpansionModule,
    ],
    providers: [
        CardResolve,
        CardByUuidResolve,
    ],
    bootstrap: [
        CardHistoryComponent,
        CardComponent,
        AddVoucherDialogComponent,
        SuspendCardVoucherDialogComponent,
        CardErrorLogsComponent,
        UnsuspendCardDialogComponent,
        ActiveVouchersComponent,
    ]
})
export class CardModule { }
